export default () => ({
  obj: { data: {}, subscription: {} },
  saving: false,
  revPointer: 0,
})
